import type { FilterOptionItem } from '@odo/shared-ui';
import type { SortBy, SortDir } from '../../services/workQueue';

export interface FilterLine {
    label: string;
    values: readonly string[];
}

export function filterChips(lines: readonly FilterLine[]): string[] {
    return lines
        .filter((line) => line.values.length > 0)
        .map((line) => `${line.label}: ${line.values.join(', ')}`);
}

export function optionLabels(
    values: readonly string[],
    options: readonly FilterOptionItem[]
): string[] {
    const labelByValue = new Map(options.map((option) => [option.value, option.label] as const));
    return values.map((value) => labelByValue.get(value) ?? value);
}

export interface ListSort {
    sortBy: SortBy;
    dir: SortDir;
}

// The case table's column headers, sentence-cased; keyed by SortBy so a new sort fails to compile here.
const SORT_LABELS: Record<SortBy, string> = {
    aging: 'Step',
    'phase-aging': 'Phase',
    name: 'Patient',
    'aligner-progress': 'DM',
    submitted: 'Submitted',
    approved: 'Approved',
    'refi-submitted': 'Refi submitted',
    refinements: 'Refinements'
};

const DIR_ARROWS: Record<SortDir, string> = { asc: '↑', desc: '↓' };

export function sortChip(sort: ListSort, defaultSort: ListSort): string | null {
    if (sort.sortBy === defaultSort.sortBy && sort.dir === defaultSort.dir) return null;
    return `${SORT_LABELS[sort.sortBy]} ${DIR_ARROWS[sort.dir]}`;
}
